export const DELETE_WS = 'DELETE_WS';
export const DELETE_WS_SUCCESS = 'DELETE_WS_SUCCESS';
export const DELETE_WS_ERROR = 'DELETE_WS_ERROR';
